import { LOCAL_SEMANTIC_MODEL } from "../model/known-models.js";
import { applyOperationsToSemanticModel } from "./apply-operations.js";
import { normalizeLegacyAssignment } from "./profile/concepts/index.js";
import { getSemanticModelMainEntity, isSemanticModelClass, isSemanticModelGeneralization, isSemanticModelRelationship, } from "./concepts/index.js";
import { initializeSemanticModelClass, initializeSemanticModelGeneralization, initializeSemanticModelRelationship } from "./entity-initializers.js";
import { SemanticModelAdapter } from "./semantic-model-adapter.js";
/**
 * Semantic model, that is writable.
 * @deprecated Use model store instead to manage the model state.
 */
export class WritableSemanticModelAdapter extends SemanticModelAdapter {
    constructor(entityModel) {
        super(entityModel);
    }
    executeOperation(operation) {
        const results = this.executeOperations([operation]);
        return results[0];
    }
    executeOperations(operations) {
        const entities = { ...this.entityModel.entities };
        const { result, updated, removed } = applyOperationsToSemanticModel(entities, operations);
        this.entityModel.change(updated, removed);
        return result;
    }
}
/**
 * Replaces legacy qualifiers of controlled vocabulary assignments.
 */
function normalizeAssignments(entities) {
    if (entities === undefined) {
        return entities;
    }
    const result = { ...entities };
    for (const [identifier, entity] of Object.entries(result)) {
        result[identifier] = normalizeLegacyAssignment(entity);
    }
    return result;
}
/**
 * Returns entities that represent the semantic model based on the provided serialization.
 */
export function serializationToSemanticModelEntities(serialization) {
    const modelDescriptor = { ...serialization };
    const modelAlias = modelDescriptor.modelAlias;
    delete modelDescriptor.modelAlias;
    if (typeof modelAlias === "string") {
        modelDescriptor.label = { cs: modelAlias };
    }
    modelDescriptor.label ??= {};
    const entities = normalizeAssignments(modelDescriptor.entities);
    delete modelDescriptor.entities;
    const initializedEntities = {};
    for (const [id, entity] of Object.entries((entities ?? {}))) {
        if (isSemanticModelClass(entity)) {
            initializedEntities[id] = initializeSemanticModelClass(entity);
        }
        else if (isSemanticModelRelationship(entity)) {
            initializedEntities[id] = initializeSemanticModelRelationship(entity);
        }
        else if (isSemanticModelGeneralization(entity)) {
            initializedEntities[id] = initializeSemanticModelGeneralization(entity);
        }
        else {
            initializedEntities[id] = entity;
        }
    }
    const mainEntity = {
        ...modelDescriptor,
        id: modelDescriptor.modelId,
        type: [LOCAL_SEMANTIC_MODEL],
    };
    return {
        ...initializedEntities,
        [mainEntity.id]: mainEntity,
    };
}
/**
 * Serializes entities that represent single semantic model.
 */
export function semanticModelEntitiesToSerialization(entities) {
    const mainEntity = getSemanticModelMainEntity(entities);
    if (!mainEntity) {
        throw new Error("Semantic model must contain an entity with type " + LOCAL_SEMANTIC_MODEL);
    }
    const restEntities = { ...entities };
    delete restEntities[mainEntity.id];
    const serializedMainEntity = { ...mainEntity };
    delete serializedMainEntity.modelAlias;
    return {
        ...serializedMainEntity,
        // Required fields
        modelId: mainEntity.id,
        type: LOCAL_SEMANTIC_MODEL,
        entities: restEntities,
    };
}
//# sourceMappingURL=writable-semantic-model-adapter.js.map